/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "gb": {
                "nested": {
                  "model": {
                    "nested": {
                      "Business": {
                        "fields": {
                          "companiesHouseRegistrationNumber": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "type": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "legalName": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "registeredAddressToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "locationAddressToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "vatNumber": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "vatName": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "vatAddress": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "vatCountryCode": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      },
                      "Persona": {
                        "fields": {
                          "beneficialOwnerRole": {
                            "type": ".squareup.onboard.activation.common.BeneficialOwnerRole",
                            "id": 1,
                            "rule": "optional"
                          },
                          "incorrect": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "incorrectReason": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "Bank": {
                        "fields": {
                          "sortCode": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.gb?.nested?.model?.nested?.Business && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.gb?.nested?.model?.nested?.Persona && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.gb?.nested?.model?.nested?.Bank) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Business @ squareup/onboard/activation/gb/model.proto at 11:1
 */
export const Business = $root.lookupType('squareup.onboard.activation.gb.model.Business');
fixType(Business);
Builder.createAndAttachToType(Business);
/**
 * SOURCE Persona @ squareup/onboard/activation/gb/model.proto at 44:1
 */
export const Persona = $root.lookupType('squareup.onboard.activation.gb.model.Persona');
fixType(Persona);
Builder.createAndAttachToType(Persona);
/**
 * SOURCE Bank @ squareup/onboard/activation/gb/model.proto at 51:1
 */
export const Bank = $root.lookupType('squareup.onboard.activation.gb.model.Bank');
fixType(Bank);
Builder.createAndAttachToType(Bank);